import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BannerProductos from "../components/BannerProductos";
import SearchProductos from "../components/searchProductos";

export default function Productos() {
  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
      <Header />
      <BannerProductos />
      <SearchProductos />
      <Footer />
    </main>
  );
}